import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "./index.css";
import App from "./App";
import StateProvider from "./store/StateProvider";
import reducer, { initialState } from "./store/Reducer";

const root = ReactDOM.createRoot(document.getElementById("root"));
// ReactDOM.render(
//   <StateProvider reducer={reducer} initialstate={initialState}>
//     <App />
//   </StateProvider>,
//   root
// );
root.render(
  <StateProvider reducer={reducer} initialstate={initialState}>
    <App />
  </StateProvider>
);
